// ロギング関数
export const logger = {
    error: (message, error = null) => {
      console.error(`[Error] ${message}`, error);
      return null;
    },
    warn: (message) => console.warn(`[Warning] ${message}`),
    info: (message) => console.info(`[Info] ${message}`)
  };